/**
 * AB Test Controller
 *
 * Each variant is its own block, placed at its desired position in the
 * theme editor. All blocks are hidden by default (display:none in Liquid).
 * Shoplift activates the winner by calling the global setter.
 *
 * Usage (from Shoplift):
 *   window.setExchangePromise("control")   // or "a" or "b"
 *   window.setMaterialStory("control")     // or "a" or "b"
 *   window.setGalleryLayout("control")     // or "a" or "b" (PDP-11)
 *
 * URL preview: ?ab_ep=control&ab_ms=a&pdp_layout=b
 *
 * When done testing, delete the losing blocks from the theme.
 */
(function () {
  'use strict';

  // ── Hero carousel arrows (Variant A, desktop only) ──────────────────────────

  function updateArrowStates() {
    var carousel = document.querySelector('product-gallery .product-gallery__carousel');
    var prevBtn = document.querySelector('.ab-hero-arrow--prev');
    var nextBtn = document.querySelector('.ab-hero-arrow--next');
    if (!carousel || !prevBtn || !nextBtn) return;

    var cells = carousel.cells || [];
    var selectedIndex = typeof carousel.selectedIndex === 'number' ? carousel.selectedIndex : 0;

    prevBtn.disabled = selectedIndex <= 0;
    nextBtn.disabled = selectedIndex >= cells.length - 1;
  }

  function syncHeroArrows(active) {
    var imageList = document.querySelector('.product-gallery__image-list');
    if (!imageList) return;

    // Remove existing injected arrows
    var existing = imageList.querySelectorAll('.ab-hero-arrow');
    for (var i = 0; i < existing.length; i++) existing[i].remove();

    if (!active) return;

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'ab-hero-arrow ab-hero-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = '<svg aria-hidden="true" focusable="false" fill="none" width="14" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/></svg>';
    prevBtn.addEventListener('click', function () {
      var c = document.querySelector('product-gallery .product-gallery__carousel');
      if (c && c.previous) { c.previous(); updateArrowStates(); }
    });

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'ab-hero-arrow ab-hero-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = '<svg aria-hidden="true" focusable="false" fill="none" width="14" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/></svg>';
    nextBtn.addEventListener('click', function () {
      var c = document.querySelector('product-gallery .product-gallery__carousel');
      if (c && c.next) { c.next(); updateArrowStates(); }
    });

    imageList.appendChild(prevBtn);
    imageList.appendChild(nextBtn);

    // Set initial disabled state (prev disabled on first image)
    updateArrowStates();

    // Also update on scroll/snap events in case user scrolls or clicks thumbnails
    var carousel = document.querySelector('product-gallery .product-gallery__carousel');
    if (carousel) {
      carousel.addEventListener('carousel:select', updateArrowStates);
      carousel.addEventListener('carousel:settle', updateArrowStates);
      // Fallback: listen for scroll on the image list
      imageList.addEventListener('scrollend', updateArrowStates);
    }
  }

  // ── Lightbox thumbnail strip (Variants A & B, desktop only) ─────────────────

  function buildLightboxThumbStrip(pswp) {
    var layout = window.currentGalleryLayout || 'control';
    if (layout === 'control') return;
    if (!window.matchMedia('(min-width: 1000px)').matches) return;

    // Remove any existing strip (e.g. from a previous open)
    var oldStrip = pswp.element.querySelector('.ab-lb-thumb-strip');
    if (oldStrip) oldStrip.remove();

    var ds = pswp.options.dataSource;
    if (!ds || ds.length < 2) return;

    var strip = document.createElement('div');
    strip.className = 'ab-lb-thumb-strip';

    var inner = document.createElement('div');
    inner.className = 'ab-lb-thumb-strip__inner';

    ds.forEach(function (item, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ab-lb-thumb-strip__thumb' + (idx === pswp.currIndex ? ' ab-lb-thumb-strip__thumb--active' : '');
      btn.setAttribute('aria-label', item.alt || ('Image ' + (idx + 1)));

      var img = document.createElement('img');
      img.src = item.msrc || item.src;
      img.alt = item.alt || '';
      img.width = 56;
      img.height = 56;
      img.setAttribute('aria-hidden', 'true');
      btn.appendChild(img);

      btn.addEventListener('click', function () { pswp.goTo(idx); });
      inner.appendChild(btn);
    });

    strip.appendChild(inner);
    pswp.element.appendChild(strip);

    // Sync active thumb on slide change
    pswp.on('change', function () {
      var thumbs = inner.querySelectorAll('.ab-lb-thumb-strip__thumb');
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.toggle('ab-lb-thumb-strip__thumb--active', i === pswp.currIndex);
      }
      var active = inner.querySelector('.ab-lb-thumb-strip__thumb--active');
      if (active) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  }

  // Hook into lightbox:open — wait one tick for window.pswp to be populated
  document.addEventListener('lightbox:open', function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (window.pswp) buildLightboxThumbStrip(window.pswp);
      });
    });
  }, true);

  function readSectionGalleryLayout() {
    var wrapper = document.querySelector('[data-desktop-gallery-layout]');
    if (!wrapper) return null;
    return wrapper.getAttribute('data-desktop-gallery-layout') || 'control';
  }

  function activateVariant(testName, variant) {
    var all = document.querySelectorAll('[data-ab-test="' + testName + '"]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-ab-variant') === variant) {
        all[i].style.display = '';

        // If this variant wants to hide the size chart, do it
        if (all[i].hasAttribute('data-hide-size-chart')) {
          var sizeChart = document.querySelector('.size-chart-container');
          if (sizeChart) sizeChart.style.display = 'none';
        }
      } else {
        all[i].style.display = 'none';
      }
    }
  }

  window.setExchangePromise = function (variant) {
    activateVariant('exchange-promise', variant);
  };

  window.setMaterialStory = function (variant) {
    activateVariant('material-story', variant);
  };

  // Gallery Layout (PDP-11): CSS override injection — no DOM changes.
  // Overrides CSS custom properties on the product section to switch
  // between grid (control), carousel_thumbnails_left (a), or grid_2x (b).
  // Desktop only (@media min-width: 1000px). Mobile is unaffected.
  window.setGalleryLayout = function (variant) {
    var existing = document.getElementById('ab-gallery-style');
    if (existing) existing.remove();
    if (!variant || variant === 'control') {
      // Restore hidden class on thumbnail list when reverting to control
      var thumbs = document.querySelector('.product-gallery__thumbnail-list');
      if (thumbs && !thumbs.classList.contains('hidden')) thumbs.classList.add('hidden');
      syncHeroArrows(false);
      return;
    }

    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;
    var section = gallery.closest('[id^="shopify-section"]');
    if (!section) return;
    var id = '#' + section.id;
    var css = '';

    // !important needed to beat the Liquid-generated <style> block inside the
    // section which has equal specificity but appears later in the DOM.
    if (variant === 'a') {
      // carousel_thumbnails_left: hero + vertical thumbnail strip on left
      // .product-gallery__image-list needs an explicit height so scroll-carousel
      // (which uses adaptive-height) can measure its content and not collapse to 0px.
      css = '@media(min-width:1000px){' + id + '{' +
        '--product-gallery-carousel-grid:auto/auto-flow 100% !important;' +
        '--product-gallery-carousel-scroll-snap-type:x mandatory !important;' +
        '--product-gallery-carousel-gap:0px !important;' +
        '--product-gallery-thumbnail-list-max-height:auto !important;' +
      '} ' + id + ' .product-gallery{--product-gallery-gap:1rem !important;--product-gap:1rem !important;} ' +
        id + ' .product-gallery__image-list{height:auto !important;max-height:none !important;}}';
    } else if (variant === 'b') {
      // grid_2x: 2-column paired grid
      css = '@media(min-width:1000px){' + id + '{' +
        '--product-gallery-carousel-grid:auto-flow dense/repeat(2,minmax(0,1fr)) !important;' +
      '}}';
    }

    // For variant A, also force-show thumbnails on desktop only.
    // The `hidden` class beats `md:block` due to source order, so we must remove it.
    // IMPORTANT: only do this on desktop — on mobile the thumbnail strip must stay hidden.
    var thumbList = document.querySelector('.product-gallery__thumbnail-list');
    var isDesktop = window.matchMedia('(min-width: 1000px)').matches;
    if (thumbList) {
      if (variant === 'a' && isDesktop) {
        thumbList.classList.remove('hidden');
      } else {
        // Restore hidden class for non-thumbnail variants
        if (!thumbList.classList.contains('hidden') && !thumbList.classList.contains('md:hidden')) {
          thumbList.classList.add('hidden');
        }
      }
    }

    var style = document.createElement('style');
    style.id = 'ab-gallery-style';
    style.textContent = css;
    document.head.appendChild(style);

    // Inject/remove hero arrows for Variant A (desktop only)
    syncHeroArrows(variant === 'a' && window.matchMedia('(min-width: 1000px)').matches);
  };

  // Track the current gallery layout variant so we can re-apply after AJAX rebuilds.
  // ajax-pdp.js rebuilds gallery DOM on color switch, which re-adds the `hidden` class
  // to .product-gallery__thumbnail-list from the Liquid template.
  var _currentGalleryVariant = null;

  // Wrap setGalleryLayout to track the current variant
  var _setGallery = window.setGalleryLayout;
  window.setGalleryLayout = function (variant) {
    _currentGalleryVariant = variant || null;
    _setGallery(variant);
  };

  Object.defineProperty(window, 'currentGalleryLayout', {
    get: function () { return _currentGalleryVariant || 'control'; },
    configurable: true
  });

  // Watch for gallery DOM rebuilds and re-apply thumbnail visibility.
  // disconnect() before our own DOM changes to prevent infinite loop.
  var galleryEl = document.querySelector('.product-gallery');
  if (galleryEl) {
    var _galleryObserver = new MutationObserver(function () {
      if (!_currentGalleryVariant || _currentGalleryVariant === 'control') return;
      var isDesktop = window.matchMedia('(min-width: 1000px)').matches;
      var thumbList = document.querySelector('.product-gallery__thumbnail-list');

      // Pause observing before our own DOM changes
      _galleryObserver.disconnect();

      if (thumbList && _currentGalleryVariant === 'a' && thumbList.classList.contains('hidden') && isDesktop) {
        thumbList.classList.remove('hidden');
      }
      if (_currentGalleryVariant === 'a' && isDesktop) {
        syncHeroArrows(true);
      }

      // Resume observing
      _galleryObserver.observe(galleryEl, { childList: true, subtree: true });
    });
    _galleryObserver.observe(galleryEl, { childList: true, subtree: true });
  }

  // Wire up Variant B's "size chart" link to open the existing size chart modal
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.ab-ep-size-chart-link');
    if (!link) return;
    // Find the existing size chart modal trigger and click it
    var existingBtn = document.querySelector('.size-chart-container button[aria-controls]');
    if (existingBtn) existingBtn.click();
  });

  // URL param preview: ?ab_ep=control&ab_ms=a (or b, control)
  // Lets you preview any variant in the browser without Shoplift
  var params = new URLSearchParams(window.location.search);
  var epParam = params.get('ab_ep');
  var msParam = params.get('ab_ms');
  var glParam = params.get('pdp_layout');
  var sectionLayout = readSectionGalleryLayout();
  if (sectionLayout && sectionLayout !== 'control') {
    window.setGalleryLayout(sectionLayout);
  }
  if (epParam) activateVariant('exchange-promise', epParam);
  if (msParam) activateVariant('material-story', msParam);
  // Query param always wins
  if (glParam) window.setGalleryLayout(glParam);

  // Theme editor: preview toggling via data-ab-preview attributes
  // Liquid outputs data-ab-preview-{testName}="{variant}" on a sentinel element.
  // When global settings change, Shopify re-renders the section HTML but may cache
  // the inline styles. This JS reads the sentinel and forces the correct variant visible.
  if (window.Shopify && window.Shopify.designMode) {
    function syncEditorPreview() {
      var sentinel = document.querySelector('[data-ab-preview-exchange-promise]');
      if (sentinel) {
        var ep = sentinel.getAttribute('data-ab-preview-exchange-promise');
        var ms = sentinel.getAttribute('data-ab-preview-material-story');
        if (ep && ep !== 'hidden') activateVariant('exchange-promise', ep);
        if (ms && ms !== 'hidden') activateVariant('material-story', ms);
        var gl = readSectionGalleryLayout();
        if (gl && gl !== 'control') {
          window.setGalleryLayout(gl);
        } else if (gl) {
          var abStyle = document.getElementById('ab-gallery-style');
          if (abStyle) abStyle.remove();
          window.setGalleryLayout(null);
        }
        if (ep === 'hidden') {
          var allEp = document.querySelectorAll('[data-ab-test="exchange-promise"]');
          for (var i = 0; i < allEp.length; i++) allEp[i].style.display = 'none';
        }
        if (ms === 'hidden') {
          var allMs = document.querySelectorAll('[data-ab-test="material-story"]');
          for (var j = 0; j < allMs.length; j++) allMs[j].style.display = 'none';
        }
      }
    }

    // Run on section load/re-render
    document.addEventListener('shopify:section:load', syncEditorPreview);

    // Poll for setting changes (Shopify doesn't fire events for global setting changes)
    var _editorPollId = setInterval(syncEditorPreview, 400);
    document.addEventListener('shopify:section:unload', function () {
      clearInterval(_editorPollId);
    });
  }
})();

